import script from "./power-of-attorney.vue?vue&type=script&lang=ts&setup=true"
export * from "./power-of-attorney.vue?vue&type=script&lang=ts&setup=true"

import "./power-of-attorney.vue?vue&type=style&index=0&id=57c8cd8e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57c8cd8e"]])

export default __exports__